import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import SettingsPanel from "../../components/SettingsPanel";
import RecentlyViewedList from "../../../../Components/Common/RecentlyViewedList";
import { getRecentlyViewedList } from "../../../../store/recentlyViewed/action";

// Recently Viewed inside Settings > My Profile. Renders the exact same
// data as the standalone /recently-viewed page (shared RecentlyViewedList
// component + recentlyViewed Redux store).
export default function RecentlyViewedSettings() {
  const dispatch = useDispatch();

  const { recentlyViewedList, loading } = useSelector((state) => ({
    recentlyViewedList:
      state.RecentlyViewed?.recentlyViewedList?.userrecentlyviewed_list,
    loading: state.RecentlyViewed?.loading,
  }));

  useEffect(() => {
    dispatch(getRecentlyViewedList());
  }, [dispatch]);

  return (
    <SettingsPanel
      title="Recently Viewed"
      description="Customers, jobs and tasks you have recently opened."
    >
      <RecentlyViewedList items={recentlyViewedList} loading={loading} />
    </SettingsPanel>
  );
}
